import { render, staticRenderFns } from "./site-dashboard.vue?vue&type=template&id=789f6bce"
import script from "./site-dashboard.vue?vue&type=script&lang=js"
export * from "./site-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports